import React from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { isUserAuthenticated } from "@/helpers";

// parentCategories/equipmentCategories are fetched by Topbar on mount (only once a
// token exists), so equipmentCategories stays null forever for a logged-out user —
// defer to children (which contains ProtectedRoute) so the "/" redirect still fires
// instead of spinning forever.
// See SH auth/SSO race-condition fix for why this distinction matters.
const CurriculumGuard = ({ children, fallback }) => {
  const parentCategories = useSelector((state) => state.equipment.parentCategories);
  const equipmentCategories = useSelector((state) => state.equipment.equipmentCategories);

  const authed = isUserAuthenticated();

  if (!authed) {
    return children;
  }

  if (equipmentCategories === null) {
    return (
      <div className="d-flex center flex-grow-1 vh-100">
        <Spinner animation="border" className="d-flex align-self-center" />
      </div>
    );
  }

  if (!parentCategories?.includes("curriculum")) {
    return fallback;
  }

  return children;
};

export default CurriculumGuard;
